import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { backendUrl } from '../../utils/constants/url';
import { TRefreshRequest, type TAuthRequest, type TAuthResponse } from '../types/AuthTypes';

// The trader cabinet is for traders and for support admins (who only get the "Саппорт" page)
export const acceptsCabinetLogin = (response: TAuthResponse) => Boolean(response.trader || response.admin);

// Role kept for routing after reload: a support admin must not land on trader-only pages
export const cabinetRole = (response: TAuthResponse): 'trader' | 'admin' => (response.trader ? 'trader' : 'admin');

export const AuthApi = createApi({
  reducerPath: 'AuthApi',
  tagTypes: ['Auth'],
  baseQuery: fetchBaseQuery({ baseUrl: `${backendUrl}/auth` }),
  endpoints: (build) => ({
    auth: build.mutation<TAuthResponse, TAuthRequest>({
      query: (body: TAuthRequest) => ({
        url: 'token/login/',
        method: 'POST',
        body,
      }),
      transformResponse: (response: TAuthResponse) => {
        if (!acceptsCabinetLogin(response)) {
          throw new Error('Invalid username or password');
        }
        return response;
      },
    }),
    refresh: build.mutation<TAuthResponse, TRefreshRequest>({
      query: (body: TRefreshRequest) => ({
        url: 'token/refresh/',
        method: 'POST',
        body,
      }),
      transformErrorResponse: (response: any) => {
        if (response.status === 401 || response.status === 403) {
          window.location.href = '/';
          localStorage.removeItem('refresh_token');
        }
      },
    }),
  }),
});

export const { useAuthMutation, useRefreshMutation } = AuthApi;
